// extracted by mini-css-extract-plugin
export var active = "style-module--active--ltQbK";
export var imglyTypoButton = "style-module--imgly--typo-button--2OOZf";
export var imglyTypoButtonSmall = "style-module--imgly--typo-button-small--P017W";
export var imglyTypoH1 = "style-module--imgly--typo-h1--hs9yH";
export var imglyTypoH2 = "style-module--imgly--typo-h2--GxTGQ";
export var imglyTypoH2BodyText = "style-module--imgly--typo-h2-body-text--uKzG0";
export var imglyTypoH3 = "style-module--imgly--typo-h3--ypfpZ";
export var imglyTypoH3BodyText = "style-module--imgly--typo-h3-body-text--LwYfM";
export var imglyTypoH4 = "style-module--imgly--typo-h4--jU5gI";
export var imglyTypoH5 = "style-module--imgly--typo-h5--qBOzA";
export var imglyTypoH5IsSmall = "style-module--imgly--typo-h5-is-small--I5jnH";
export var imglyTypoIcon = "style-module--imgly--typo-icon--nWFRh";
export var imglyTypoLink = "style-module--imgly--typo-link--KcRGJ";
export var imglyTypoOverline = "style-module--imgly--typo-overline--acqyD";
export var imglyTypoOverlineSmall = "style-module--imgly--typo-overline-small--TwK53";
export var imglyTypoParagraph = "style-module--imgly--typo-paragraph--ZWiRM";
export var imglyTypoParagraphBig = "style-module--imgly--typo-paragraph-big--GwlyB";
export var imglyTypoParagraphBodyText = "style-module--imgly--typo-paragraph-body-text--pEtu6";
export var imglyTypoParagraphSmall = "style-module--imgly--typo-paragraph-small--tnbel";
export var imglyTypoSubline = "style-module--imgly--typo-subline--qr4T0";
export var imglyTypoSublineBodyText = "style-module--imgly--typo-subline-body-text--TAJJs";
export var item = "style-module--item--kCQcG";
export var link = "style-module--link--b7GqP";
export var list = "style-module--list--oFyxH";
export var naviLabelIsLarge = "style-module--navi-label-is-large--BNvzk";
export var naviLabelIsSmall = "style-module--navi-label-is-small--EKMK8";